const CONFIG = {
  TIMEOUTS: {
    POST_RELOAD_ACTIONS: 200,
    DOWNLOAD_TRIGGER: 500,
    SCROLL_DELAY: 1000,
    FORM_SUCCESS_DELAY: 100
  },
  THUMBNAILS: {
    COMPACT: { WIDTH: 100, HEIGHT: 150 },
    DETAILED: { WIDTH: 250, HEIGHT: 350 }
  },
  STORAGE_KEYS: {
    PENDING_DOWNLOAD: 'pendingInlineDownload',
    SCROLL_TARGET: 'scrollToDownloadIndex'
  },
  SELECTORS: {
    CONTENT_SECTION: '.article-template__content',
    DOWNLOAD_LIST: '[data-download-list]',
    DOWNLOAD_ITEM: '.download-list-item'
  },
  REGEX: {
    PLACEHOLDER: /\[\[download-(\d+)(?:-(email|noemail)-(detailed|compact))?\]\]/g
  }
};

window.addEventListener('DOMContentLoaded', () => {
  initializeDownloadSystem();
});

function initializeDownloadSystem() {
  window.usedInlineDownloads = new Set();
  window.downloadIcons = extractIconsFromDOM();

  const contentSection = document.querySelector(CONFIG.SELECTORS.CONTENT_SECTION);
  if (!contentSection) {
    return;
  }

  const downloadsAlreadyUnlocked = window.DownloadList && window.DownloadList.hasFormBeenSubmitted();

  processDownloadPlaceholders(contentSection, downloadsAlreadyUnlocked);
  hideUsedDownloadsFromBottomList();

  setTimeout(handlePostReloadActions, CONFIG.TIMEOUTS.POST_RELOAD_ACTIONS);
}

function processDownloadPlaceholders(contentSection, downloadsAlreadyUnlocked) {
  const textNodes = findTextNodesWithPlaceholders(contentSection);

  textNodes.forEach(node => {
    const matches = [...node.nodeValue.matchAll(CONFIG.REGEX.PLACEHOLDER)];
    matches.reverse().forEach(match => {
      const placeholderData = parsePlaceholderMatch(match);
      window.usedInlineDownloads.add(placeholderData.downloadIndex);

      const placeholderNode = createPlaceholderNode(node, match);
      const fileMetaobject = getFileByIndex(placeholderData.downloadIndex);

      if (fileMetaobject) {
        const downloadElement = createConfiguredDownloadElement(
          fileMetaobject,
          placeholderData.emailRequired && !downloadsAlreadyUnlocked,
          placeholderData.detailedView,
          placeholderData.downloadIndex
        );
        placeholderNode.parentNode.replaceChild(downloadElement, placeholderNode);
      } else {
        placeholderNode.parentNode.removeChild(placeholderNode);
      }
    });
  });
}

function findTextNodesWithPlaceholders(contentSection) {
  const walker = document.createTreeWalker(contentSection, NodeFilter.SHOW_TEXT);
  const textNodes = [];

  while (walker.nextNode()) {
    if (walker.currentNode.nodeValue.includes('[[download-')) {
      textNodes.push(walker.currentNode);
    }
  }

  return textNodes;
}

function parsePlaceholderMatch(match) {
  const downloadIndex = parseInt(match[1]) - 1;
  const isExtendedFormat = match[2] !== undefined;

  let emailRequired, detailedView;
  if (isExtendedFormat) {
    emailRequired = match[2] === 'email';
    detailedView = match[3] === 'detailed';
  } else {
    emailRequired = true;
    detailedView = true;
  }

  return { downloadIndex, emailRequired, detailedView };
}

function createPlaceholderNode(node, match) {
  const matchIndex = match.index;
  const fullPlaceholder = match[0];

  let placeholderNode = node.splitText(matchIndex);
  placeholderNode.splitText(fullPlaceholder.length);

  return placeholderNode;
}

function handlePostReloadActions() {
  const urlParams = new URLSearchParams(window.location.search);
  const hasFormFragment = window.location.hash && window.location.hash.includes('DownloadForm-');
  const isFormSuccessPage = urlParams.get('contact_posted') === 'true' && hasFormFragment;

  if (isFormSuccessPage) {
    return;
  }

  handlePendingDownload();
  setTimeout(handlePostReloadScrolling, CONFIG.TIMEOUTS.SCROLL_DELAY);
}

function handlePendingDownload() {
  if (window.DownloadList && window.DownloadList.getPendingDownloadUrl) {
    const downloadListPending = window.DownloadList.getPendingDownloadUrl();
    if (downloadListPending) {
      return;
    }
  }

  const pendingDownload = sessionStorage.getItem(CONFIG.STORAGE_KEYS.PENDING_DOWNLOAD);
  if (!pendingDownload) return;

  try {
    const downloadData = JSON.parse(pendingDownload);
    sessionStorage.removeItem(CONFIG.STORAGE_KEYS.PENDING_DOWNLOAD);

    setTimeout(() => {
      triggerDownload(downloadData.url, downloadData.filename);
    }, CONFIG.TIMEOUTS.DOWNLOAD_TRIGGER);
  } catch (e) {
    sessionStorage.removeItem(CONFIG.STORAGE_KEYS.PENDING_DOWNLOAD);
  }
}

function handlePostReloadScrolling() {
  if (window.DownloadList && window.DownloadList.getScrollTarget) {
    const downloadListTarget = window.DownloadList.getScrollTarget();
    if (downloadListTarget) {
      return;
    }
  }

  const scrollToIndex = sessionStorage.getItem(CONFIG.STORAGE_KEYS.SCROLL_TARGET);
  if (scrollToIndex === null) return;

  const targetId = `${parseInt(scrollToIndex) + 1}`;
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    scrollToCenter(targetElement);
  }
  sessionStorage.removeItem(CONFIG.STORAGE_KEYS.SCROLL_TARGET);
}

function triggerDownload(url, filename = '') {
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

function scrollToCenter(target) {
  if (target) {
    target.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
  }
}

function extractIconsFromDOM() {
  const icons = {};

  const downloadIcon = document.querySelector('.download-list-snippet .icon-wrap');
  if (downloadIcon) {
    icons.download = downloadIcon.innerHTML.trim();
  }

  const closeIcon = document.querySelector('.download-popup-modal__toggle');
  if (closeIcon) {
    icons.close = closeIcon.innerHTML.trim();
  }

  const emptyFileIcon = document.querySelector('.download-list-thumbnail svg');
  if (emptyFileIcon) {
    icons.emptyFile = emptyFileIcon.outerHTML;
  }

  return icons;
}

function hideUsedDownloadsFromBottomList() {
  window.usedInlineDownloads.forEach(index => {
    const downloadId = `download-${index + 1}`;
    const downloadElement = document.querySelector('.download-list-snippet #' + downloadId);

    if (downloadElement) {
      downloadElement.style.display = 'none';
    }
  });

  const downloadList = document.querySelector('[data-download-list]');
  if (downloadList) {
    const visibleDownloads = downloadList.querySelectorAll('.download-list-item:not([style*="display: none"])');
    if (visibleDownloads.length === 0) {
      downloadList.style.display = 'none';
    }
  }
}

function getFileByIndex(index) {
  if (window.articleDownloads && window.articleDownloads[index]) {
    return window.articleDownloads[index];
  }
  return null;
}

function createConfiguredDownloadElement(file, emailRequired, detailedView, index) {
  const stableId = `${index+1}`;
  const wrapper = document.createElement('div');
  wrapper.className = `download-inline-wrapper ${detailedView ? 'detailed-view' : 'compact-view'}`;
  wrapper.setAttribute('data-download-inline', stableId);
  wrapper.id = stableId;

  if (detailedView) {
    wrapper.innerHTML = createDetailedHTML(file, emailRequired, stableId);
  } else {
    wrapper.innerHTML = createCompactHTML(file, emailRequired, stableId);
  }

  initializeInlineDownload(wrapper, file, emailRequired, index);

  return wrapper;
}

function createThumbnailHTML(file, size) {
  const { WIDTH: width, HEIGHT: height } = CONFIG.THUMBNAILS[size];
  return file.thumbnail
    ? `<img src="${file.thumbnail}" width="${width}" height="${height}" alt="${file.name}">`
    : (window.downloadIcons?.emptyFile || '');
}

function createDownloadLinkHTML(file, uniqueId, isHidden = false, thumbnailSize = 'COMPACT', showThumbnail = true) {
  const hiddenAttr = isHidden ? 'data-download-link="hidden" style="display: none;"' : 'data-download-link';

  return `
    <a class="download-list-file-item link animate-arrow"
       href="${file.file_url}"
       download
       ${hiddenAttr}>
      ${showThumbnail ? `<div class="download-list-thumbnail">
        ${createThumbnailHTML(file, thumbnailSize)}
      </div>` : ''}
      <div class="download-list-file-info">
        <div class="download-list-file-name"><span>${file.name}</span></div>
      </div>
      <span class="svg-wrapper">
        <span class="icon-wrap">${window.downloadIcons?.download || ''}</span>
      </span>
    </a>
  `;
}

function createModalFormHTML(uniqueId, file) {
  return `
    <modal-dialog id="DownloadModal-${uniqueId}" class="download-popup-modal">
      <div role="dialog" aria-label="Download Form" aria-modal="true" class="download-popup-modal__content" tabindex="-1">
        <button id="ModalClose-${uniqueId}" type="button" class="download-popup-modal__toggle" aria-label="Close">
          ${window.downloadIcons?.close || '×'}
        </button>
        <div class="download-popup-modal__content-info">
          <p>Please fill out the form below to download this file.</p>
          <form id="DownloadForm" class="download-form" data-download-form="true" data-inline-form="${uniqueId}" data-download-id="DownloadForm-${uniqueId}">
            <input type="hidden" name="contact[tags]" value="newsletter">
            <div class="newsletter-form__field-wrapper">
              <div class="field field-hidden" style="display: none;">
                <input class="field__input" type="text" id="ContactForm-download-${uniqueId}" name="contact[download]" value="${file.file_url}">
              </div>
              <div class="field">
                <input class="field__input" type="text" required id="ContactForm-firstname-${uniqueId}" name="contact[firstname]" placeholder="First Name">
                <label class="field__label" for="ContactForm-firstname-${uniqueId}">First Name <span aria-hidden="true">*</span></label>
              </div>
              <div class="field">
                <input class="field__input" type="text" required id="DownloadForm-lastname-${uniqueId}" name="contact[lastname]" placeholder="Last Name">
                <label class="field__label" for="DownloadForm-lastname-${uniqueId}">Last Name <span aria-hidden="true">*</span></label>
              </div>
              <div class="field">
                <input class="field__input" type="email" required id="DownloadForm-email-${uniqueId}" name="contact[email]" placeholder="Email">
                <label class="field__label" for="DownloadForm-email-${uniqueId}">Email <span aria-hidden="true">*</span></label>
              </div>
              <div class="contact__button" id="contact-consent-communications-container-${uniqueId}">
                <input type="checkbox" name="contact[consent_to_communications]" id="contact-consent-communications-${uniqueId}">
                <label for="contact-consent-communications-${uniqueId}">I agree to receive communications from Single Use Support. You can unsubscribe at any time. Check our <a href="/pages/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></label>
              </div>
              <button type="submit" class="button">Submit ${window.downloadIcons?.download || ''}</button>
            </div>
          </form>
        </div>
      </div>
    </modal-dialog>
  `;
}

function createInlineFormHTML(uniqueId, file) {
  return `
    <div class="form-container" data-form-container style="display: block;">
      <form id="DownloadForm" class="download-form" data-download-form="true" data-inline-form="${uniqueId}" data-download-id="DownloadForm-${uniqueId}">
        <input type="hidden" name="contact[tags]" value="newsletter">
        <div class="newsletter-form__field-wrapper">
          <div class="field field-hidden" style="display: none;">
            <input class="field__input" type="text" id="ContactForm-download-${uniqueId}" name="contact[download]" value="${file.file_url}">
          </div>
          <div class="input-group">
            <label>
              <input
                autocomplete="email"
                type="email"
                class="email-input"
                name="contact[email]"
                placeholder="Email"
                required
              >
            </label>
            <button type="submit" class="button download-list-gated__submit">${window.downloadIcons?.download || ''} Download</button>
          </div>
          <div class="field field-hidden" style="display: none;">
            <input class="field__input" type="text" id="ContactForm-download-${uniqueId}" name="contact[download]" value="${file.file_url}">
          </div>
          <div class="contact__button" id="contact-consent-communications-container-${uniqueId}">
            <input type="checkbox" name="contact[consent_to_communications]" id="contact-consent-communications-${uniqueId}">
            <label for="contact-consent-communications-${uniqueId}">I agree to receive communications from Single Use Support. You can
              unsubscribe at any time. Check our <a href="/pages/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </label>
          </div>
          <button type="submit" class="button download-list-gated__submit-mobile">${window.downloadIcons?.download || ''} Download</button>
        </div>
      </form>
    </div>
  `;
}

function createCompactHTML(file, emailRequired, uniqueId) {
  if (emailRequired) {
    return `
      <div class="download-list-file-item download-list-item" id="download-${uniqueId}" data-gated-download>
        <div class="download-list-thumbnail">
          ${createThumbnailHTML(file, 'COMPACT')}
        </div>
        <div class="download-list-file-info">
          <div class="download-list-file-name"><span>${file.name}</span></div>
        </div>
        <modal-opener class="download-icon-wrapper" data-modal="#DownloadModal-${uniqueId}" data-modal-opener>
          <button type="button" class="download-icon-button" aria-haspopup="dialog">
            <span class="svg-wrapper">
              <span class="icon-wrap">${window.downloadIcons?.download || ''}</span>
            </span>
          </button>
        </modal-opener>

        ${createModalFormHTML(uniqueId, file)}
        ${createDownloadLinkHTML(file, uniqueId, true, 'COMPACT')}
      </div>
    `;
  } else {
    return `
      <div class="download-list-item" id="download-${uniqueId}">
        ${createDownloadLinkHTML(file, uniqueId, false, 'COMPACT')}
      </div>
    `;
  }
}

function createDetailedHTML(file, emailRequired, uniqueId) {
  return `
    <div class="download-list-gated download-list-item detailed-view" id="download-${uniqueId}">
      <div class="thumbnail">
        ${createThumbnailHTML(file, 'DETAILED')}
      </div>
      <div class="download-list-gated__body">
        ${file.pretitle ? `<p class="pretitle heading-topline">${file.pretitle}</p>` : ''}
        <div class="text">
          <h3>${file.name}</h3>
          ${file.description ? `<div class="file-description">${file.description}</div>` : ''}
        </div>
        <div class="download-form">
          ${emailRequired ? createInlineFormHTML(uniqueId, file) : ''}
          ${createDownloadLinkHTML(file, uniqueId, emailRequired, 'COMPACT', false)}
        </div>
      </div>
    </div>
  `;
}

function initializeInlineDownload(wrapper, file, emailRequired, index) {
  if (!emailRequired) return;

  if (window.DownloadList && window.DownloadList.hasFormBeenSubmitted()) {
    unlockInlineDownload(wrapper);
    return;
  }

  attachFormSubmissionHandlers(wrapper, file, index);
  attachModalClickHandlers(wrapper);
}

function attachModalClickHandlers(wrapper) {
  const gatedElement = wrapper.querySelector('[data-gated-download]');
  const modalOpener = wrapper.querySelector('[data-modal-opener]');
  const downloadButton = wrapper.querySelector('.download-icon-button');

  if (gatedElement && modalOpener && downloadButton) {
    gatedElement.addEventListener('click', function(event) {
      if (event.target.closest('.download-icon-button')) {
        return;
      }

      downloadButton.click();
    });

    gatedElement.style.cursor = 'pointer';
  }
}

function attachFormSubmissionHandlers(wrapper, file, index) {
  const forms = wrapper.querySelectorAll('[data-inline-form]');
  forms.forEach(form => {
    form.addEventListener('submit', (e) => {
      if (window.globalEmailValidator && !window.globalEmailValidator.validateAndPreventSubmit(form, e)) {
        return false;
      }

      handleInlineFormSubmit(e, file, index);
    });
  });
}

function handleInlineFormSubmit(event, file, index) {
  updateDownloadState(index);
  const downloadData = prepareDownloadData(file);
  storeDownloadData(downloadData);
}

function updateDownloadState(index) {
  if (window.DownloadList) {
    window.DownloadList.setFormAsSubmitted();
    sessionStorage.setItem(CONFIG.STORAGE_KEYS.SCROLL_TARGET, index.toString());
  }
}

function prepareDownloadData(file) {
  const filename = extractFilename(file.file_url, file.name);
  return {
    url: file.file_url,
    filename: filename
  };
}

function extractFilename(fileUrl, fallbackName) {
  try {
    let urlPath;
    if (fileUrl.startsWith('http')) {
      const url = new URL(fileUrl);
      urlPath = url.pathname;
    } else {
      urlPath = fileUrl.split('?')[0].split('#')[0];
    }

    let filename = urlPath.split('/').pop();

    if (filename && filename.includes('_v=')) {
      filename = filename.split('_v=')[0];
    }

    return (!filename || filename === '') ? fallbackName : filename;
  } catch (e) {
    return fallbackName;
  }
}

function storeDownloadData(downloadData) {
  sessionStorage.setItem(CONFIG.STORAGE_KEYS.PENDING_DOWNLOAD, JSON.stringify(downloadData));
}

function unlockInlineDownload(wrapper) {
  const formContainers = wrapper.querySelectorAll('.form-container');
  const modals = wrapper.querySelectorAll('.download-popup-modal');
  const hiddenLinks = wrapper.querySelectorAll('[data-download-link="hidden"]');

  formContainers.forEach(container => {
    container.style.display = 'none';
  });

  modals.forEach(modal => {
    modal.style.display = 'none';
  });

  hiddenLinks.forEach(link => {
    link.style.display = '';
    link.setAttribute('data-download-link', 'visible');
  });
}

function handleInlineFormSubmission(wrapper, file) {
  if (window.DownloadList) {
    window.DownloadList.setFormAsSubmitted();
  }

  unlockInlineDownload(wrapper);
  document.body.classList.remove('modal-open');

  const filename = extractFilename(file.file_url, file.name);
  triggerDownload(file.file_url, filename);

  if (window.DownloadList) {
    setTimeout(() => {
      window.DownloadList.handleFormSuccess();
    }, CONFIG.TIMEOUTS.FORM_SUCCESS_DELAY);
  }
}
